
import { Component, OnInit } from '@angular/core';
import { ColPropConfig, ComboPropConfig, DgDynamicGridComponent } from 'dg-dynamic-grid-lib';
import { AppInitService } from 'src/app/digigov/services/app-init.service';
import { EmsServiceService } from '../sevices/ems-service.service';

@Component({
    selector: 'app-build-popup',
    templateUrl: './build-popup.component.html',
    styleUrls: ['./build.popup.component.scss'],
  })

  export class BuildPopupComponent implements OnInit
  {

    colPropConfig: ColPropConfig = {
        idProp: 'columnId',
        nameProp: 'columnName',
        typeProp: 'type',
        placeholderProp: 'placeholder',
        requiredProp: 'mandatory',
        comboProp: 'comboItems',
        validationsProp: 'validations',
      };
    
      comboPropConfig: ComboPropConfig = {
        labelProp: 'optionText',
        valueProp: 'optionValue',
        disabledProp: 'optionDisabled',
        iconProp: 'optionIcon',
      };

    rowBuildArray=[];
    colBuildArray=[
        
          {
            columnName: 'Module Name',
            columnId: 'module',
            displayable: true,
            width:225
          },
          {
            columnName: 'API Build',
            columnId: 'api',
            displayable: true,
          },
          {
            columnName: 'UI Build',
            columnId: 'ui',
            displayable: true,
          },
          {
            columnName: 'Batch Build',
            columnId: 'batch',
            displayable: true,
          },
    ];
    constructor(private emsService:EmsServiceService)
    {
      
    }
        
    ngOnInit(): void 
    {
       this.fetchBuildDetails();
    }


    fetchBuildDetails()
    {
      this.emsService.getBuildDetails().subscribe(
        (response)=>
        {
          console.log(response)
          if(response)
          {
            this.rowBuildArray=response["data"];
          }
        }
      );
    }
  }